export const tourText = {
  libraryOverview: {
    title: 'Your Library',
    description: 'Manage all uploaded content here.',
  },
  libraryUpload: {
    title: 'Upload Files',
    description: 'Click here to upload new files.',
  },
  librarySearch: {
    title: 'Search Library',
    description: 'Find files quickly using the search.',
  },
};
